import FormikInput from './FormikInput';
import FormikPhoneInput from './FormikPhoneInput';

export default FormikInput;
export { FormikPhoneInput };
